import { render, staticRenderFns } from "./RolePermissionEdit.vue?vue&type=template&id=07dd8980&"
import script from "./RolePermissionEdit.vue?vue&type=script&lang=js&"
export * from "./RolePermissionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports